















import Vue from "vue";
import NoteItem from "./NoteItem.vue";

export default Vue.extend({
  components: {
    NoteItem,
  },
  computed: {
      retrievedNotes(){
          const notes = this.$store.getters["notes/notes"];
          return notes
      }
  },
});
